export default __webpack_public_path__ + "static/media/wyscig.6cb8579c.png";